import { render, staticRenderFns } from "./CalendarEditPlace.vue?vue&type=template&id=59b0bc0e&scoped=true&"
import script from "./CalendarEditPlace.vue?vue&type=script&lang=js&"
export * from "./CalendarEditPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b0bc0e",
  null
  
)

export default component.exports